import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PDFViewerState {
  isOpen: boolean;
  pdfUrl: string | null;
  documentoNombre: string | null;
}

interface PDFViewerContextType extends PDFViewerState {
  openViewer: (url: string, nombre: string) => void;
  closeViewer: () => void;
}

const PDFViewerContext = createContext<PDFViewerContextType | undefined>(undefined);

export const PDFViewerProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [state, setState] = useState<PDFViewerState>({
    isOpen: false,
    pdfUrl: null,
    documentoNombre: null,
  });

  const openViewer = (url: string, nombre: string) => {
    setState({ isOpen: true, pdfUrl: url, documentoNombre: nombre });
  };

  const closeViewer = () => {
    // Revoke the blob URL to free memory
    if (state.pdfUrl && state.pdfUrl.startsWith('blob:')) {
      URL.revokeObjectURL(state.pdfUrl);
    }
    setState({ isOpen: false, pdfUrl: null, documentoNombre: null });
  };

  return (
    <PDFViewerContext.Provider value={{ ...state, openViewer, closeViewer }}>
      {children}
    </PDFViewerContext.Provider>
  );
};

export const usePDFViewer = () => {
  const context = useContext(PDFViewerContext);
  if (!context) {
    throw new Error('usePDFViewer must be used within PDFViewerProvider');
  }
  return context;
};
